const rail = {
  rails: "レール", // translated
  senior: "シニア", // translated
  seniors: "シニア", // translated
  youths: "若者", // translated
  yearOld: "歳", // translated
  yearsOld: "歳", // translated
};



export default rail;
